import { useContext, useEffect, useState } from 'react';
import useUser from '../../api/hooks/useUser';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { User } from '../../interfaces';
import { getRandomBgColor } from '../../utils/others';
import UserCard from './UserCard';
import Loader from '../Loader';
import CustomModal from '../modals/CustomModal';
import { useForm } from 'react-hook-form';
import CustomInput from '../inputs/CustomInput';
import { logMsgBgColors } from '../../consts/misc';

const UsersTable = (props: any) => {
    const { isMobile } = useIsMobile();
    const [showPopup, setShowPopup] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { write } = props.logMessage;
    const [otherUser, setOtherUser] = useState({ name: '', email: '', id: 0 });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const { isToggled } = props.resetList;

    const { user, userTreated } = useContext(MainContext);

    const { RESPONSES, RESULTS, CTAs } = useUser();

    const [usersList, setUsersList] = useState<User[]>([]);

    useEffect(() => {
        CTAs.getUsersList();
    }, [isToggled, user, userTreated]);

    useEffect(() => {
        /* console.log(RESPONSES.getUsersListResponse, RESULTS.getUsersListResult); */
        if (RESPONSES.getUsersListResponse?.ok) {
            setUsersList(RESULTS.getUsersListResult?.users);
        }
    }, [RESPONSES.getUsersListResponse]);

    const renderUsers = usersList.map((user, key) => {
        return (
            <div key={key} className='offers-table-row'>
                <UserCard user={user} deleteToggler={props.deleteToggler} bgColor={getRandomBgColor()} showPopup={setShowPopup} setOtherUser={setOtherUser} />
            </div>
        );
    });

    const handleEditUser = (data: any) => {
        setIsLoading(true);
        CTAs.editUser(data);
    };

    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.userEditResponse?.ok) {
            write('subject', 'User ');
            write('other_text', 'has been updated ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            setIsLoading(false);
            setShowPopup(false);
            CTAs.getUsersList();
        } else if (RESPONSES.userEditResponse?.ok === false) {
            write('subject', 'User');
            write('other_text', 'has not been updated');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
            setIsLoading(false);
            setShowPopup(false);
        }
    }, [RESPONSES.userEditResponse]);

    useEffect(() => {
        reset(); // Reset the form when the modal is closed
    }, [showPopup, otherUser]);

    return (
        <div
            className='users-table shadow'
            style={{
                width: isMobile ? '345px' : '',
                margin: isMobile ? '35px 16px' : '',
            }}
        >
            {showPopup && (
                <CustomModal title='Modifica' setShow={setShowPopup} description=''>
                    <form onSubmit={handleSubmit(handleEditUser)} style={{ width: '100%' }}>
                        <CustomInput title={'Nome'} name={'name'} type={'text'} register={register} placeholder={otherUser.name} errors={errors} width={'100%'} reset={reset} noIcon={true} />
                        <CustomInput title={'Email'} name={'email'} type={'text'} register={register} placeholder={otherUser.email} errors={errors} width={'100%'} reset={reset} noIcon={true} />
                        <CustomInput title={'Password'} name={'password'} type={'text'} register={register} errors={errors} width={'100%'} reset={reset} noIcon={true} />
                        <input type='text' value={otherUser.id} hidden {...register('id')} />
                        {isLoading ? (
                            <Loader />
                        ) : (
                            <button style={{ width: 70, marginTop: 20 }} className='add-button' type='submit'>
                                <p className='add-buttonText'>Salva</p>
                            </button>
                        )}
                    </form>
                </CustomModal>
            )}
            <div
                className='user-table-header'
                style={{
                    justifyContent: isMobile ? 'space-between' : '',
                    margin: '31px 25px',
                }}
            >
                <div className='user-table-header-title-box'>
                    <p className='user-table-header-title'>Other users</p>
                    <p className='user-table-header-description'>Manage users</p>
                </div>
                <button className='user-table-header-button shadow' type='button' onClick={props.toggler.toggle}>
                    <p className='user-table-header-button-text'>Add user</p>
                </button>
            </div>
            <div className='user-table-content'>
                <div className='offers-table'>
                    <div className='offers-table-fields'>
                        <div
                            className='u-name'
                            style={{
                                margin: isMobile ? '0' : '',
                            }}
                        >
                            <p className='field-label'>Name</p>
                        </div>
                        {!isMobile && (
                            <div className='u-mail'>
                                <p className='field-label'>E-mail</p>
                            </div>
                        )}
                        <div
                            className='u-status'
                            style={{
                                marginLeft: isMobile ? '135px' : '',
                            }}
                        >
                            <p className='field-label'>Role</p>
                        </div>
                    </div>
                    <div className='divider' style={{ width: '100%', marginTop: '10px' }} />
                    {usersList.length > 0 ? <div className='users-table-results scroll-y'>{renderUsers}</div> : <Loader />}
                </div>
            </div>
        </div>
    );
};
export default UsersTable;
